import { operate } from '../util/lift';
import { createOperatorSubscriber } from './OperatorSubscriber';
export function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) { inclusive = false; }
    return operate(function (source, subscriber) {
        var index = 0;
        var operatorSubscriber = createOperatorSubscriber(subscriber, function (value) {
            if (predicate(value, index++)) {
                subscriber.next(value);
            }
            else {
                operatorSubscriber.unsubscribe();
                if (inclusive) {
                    subscriber.next(value);
                }
                subscriber.complete();
            }
        });
        source.subscribe(operatorSubscriber);
    });
}
//# sourceMappingURL=takeWhile.js.map